import React from "react";

import styles from "./sass/Footer.module.sass";

export default function FooterSeparator() {
    return <div className={styles.separator} />;
}
